import type {
  FmMapWorkspaceDescriptor,
} from './FmMapWorkspaceRoot.types';
import {
  assertMapWorkspaceExactObject as exactObject,
  requireMapWorkspaceEnum,
  validateMapWorkspaceAvailabilityShape,
} from './FmMapWorkspaceValidation.shared';

export function validateMapWorkspaceOrientationShape(
  descriptor: FmMapWorkspaceDescriptor,
): void {
  const orientation = descriptor.orientation;
  if (!orientation) return;
  exactObject(
    orientation,
    [
      'locale', 'ariaLabel', 'propertyLabel', 'area', 'standCount',
      'matureStandCount', 'dominantSpecies', 'totalVolume', 'volumeRange',
      'observedOn', 'growthCalculatedTo', 'source',
    ],
    'orientation',
  );
  if (orientation.locale !== undefined) {
    requireMapWorkspaceEnum(
      orientation.locale,
      ['en', 'fi', 'sv', 'es'],
      'orientation.locale',
    );
  }
  for (const key of [
    'area', 'standCount', 'matureStandCount', 'dominantSpecies',
    'totalVolume', 'volumeRange', 'observedOn', 'growthCalculatedTo', 'source',
  ] as const) {
    validateMapWorkspaceAvailabilityShape(
      orientation[key],
      `orientation.${key}`,
    );
  }
  if (orientation.area.status === 'available') {
    exactObject(orientation.area.value, ['value', 'unit'], 'orientation.area.value');
  }
  if (orientation.volumeRange.status === 'available') {
    exactObject(
      orientation.volumeRange.value,
      ['low', 'high', 'unit'],
      'orientation.volumeRange.value',
    );
  }
  if (orientation.totalVolume.status === 'available') {
    exactObject(
      orientation.totalVolume.value,
      ['value', 'unit'],
      'orientation.totalVolume.value',
    );
  }
}
